import { create } from "zustand";

interface RevenueStoreState {
  accountId: any;
  startDate: any;
  endDate: any;
  revenueStore: any;
  setRevenueStore: (revenueStore: any) => void;
  setAccountId: (accountId: any) => void;
  setStartDate: (startDate: string) => void;
  setEndDate: (endDate: string) => void;
}

export const useRevenueStore = create<RevenueStoreState>((set) => ({
  accountId: null,
  startDate: null,
  endDate: null,
  revenueStore: null,
  setRevenueStore: (revenueStore) => set({ revenueStore }),
  setAccountId: (accountId) => set({ accountId }),
  setStartDate: (startDate) => set({ startDate }),
  setEndDate: (endDate) => set({ endDate }),
}));
